import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import MarkerClusterer from '@google/markerclusterer';
import '../../scrollbar.css';

function MapComponent({
  selectedPage,
  coordinates,
  center,
  cluster = false,
  polyline = false,
  selectedData,
  handleMapType,
  mapType,
  deviceType,
  handleBin,
  bin,
  setShowFloorMap,
  setZoomedLocationMap,
}) {
  const [mapStyle, setMaoStyle] = useState('roadmap');
  const getMapOptions = (maps) => {
    return {
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: false,
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
      minZoom: 1,
      maxZoom: 22,
      mapId: 'ef82cbc2846ded4d',
      defaultZoom: 11,
      mapTypeControl: true,
      mapTypeId: mapStyle === 'roadmap' ? maps.MapTypeId.ROADMAP : maps.MapTypeId.SATELLITE,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE, maps.MapTypeId.HYBRID],
      },

      zoomControl: true,
      clickableIcons: true,
    };
  };

  const handlegoogleApi = (map, maps, places) => {
    const markers = [];
    const bounds = new maps.LatLngBounds();
    let _ts;
    if (selectedPage === 'dashboard') {
      _ts = selectedData?.data?.response?.data?.ts.reverse();
    }
    places.forEach((place, idx) => {
      if (selectedPage === 'dashboard' && _ts && _ts.length > 0) {
        if (selectedData?.data?.response?.data?.ts.length > 0) {
          const _date = _ts[idx];
          // if (selectedData.data !== null) {
          //   if (places.length === selectedData?.data?.response?.data?.ts.length) {
          //     if (selectedData?.data?.response?.data?.ts[idx] > 9999999999) {
          //       _date = selectedData?.data?.response?.data?.ts[idx];
          //     } else {
          //       _date = selectedData?.data?.response?.data?.ts[idx] * 1000;
          //     }
          //   } else if (selectedData?.data?.response?.data?.ts[0] > 9999999999) {
          //     _date = selectedData?.data?.response?.data?.ts[0];
          //   } else {
          //     _date = selectedData?.data?.response?.data?.ts[0] * 1000;
          //   }
          // }
          // console.log('daterror', `${new Date(_date).toISOString().split('T')[0]}, ${place.lat}, ${place.lng}`);

          const _dataType = selectedData?.data?.response?.data?.DATA_TYPE.reverse();
          markers.push(
            new maps.Marker({
              position: {
                lat: parseFloat(place.lat),
                lng: parseFloat(place.lng),
              },
              icon:
                _dataType?.length > 0 && _dataType[idx].includes('GOOGLE')
                  ? 'assets/img/marker2.jfif'
                  : 'assets/img/marker.svg',
              map,
              // title: `${place.lat}, ${place.lng}`,
              // title: `${new Date(_date).toISOString().split('T')[0]}, ${place.lat}, ${place.lng}`,
              title: `${new Date(_date)}, ${place.lat}, ${place.lng}`,
              // title: `(${new Date(_date).toISOString().split('T')[0]}:${new Date(_date).toISOString().split('T')[1].split('.')[0]}, ${place.lat}, ${place.lng})`
            })
          );
        }
      }
      if (selectedPage === 'zone') {
        console.log(selectedData);
        markers.push(
          new maps.Marker({
            position: { lat: place.lat, lng: place.lng },
            icon: 'assets/img/warehouse.svg',
            map,
            title: `(${selectedData[idx]?.location}, ${selectedData[idx]?.geoLocation || ''})`,
          })
        );
      }

      if (selectedPage === 'warehouse') {
        console.log(selectedData);
        markers.push(
          new maps.Marker({
            position: { lat: place.lat, lng: place.lng },
            icon: 'assets/img/warehouse.svg',
            map,
            title: `(${selectedData[idx]?.name}, ${selectedData[idx]?.Address?.city || ''}, ${
              selectedData[idx]?.Address?.country || ''
            })`,
          })
        );
      }

      if (selectedPage === 'traceability') {
        markers.push(
          new maps.Marker({
            position: {
              lat: parseFloat(place.lat),
              lng: parseFloat(place.lng),
            },
            icon: 'assets/img/marker.svg',
            map,
            // title: `(${new Date(locationData?.data?.response?.data?.ts[idx] * 1000).toISOString().split('T')[0]}:${
            //   new Date(locationData?.data?.response?.data?.ts[idx] * 1000).toISOString().split('T')[1].split('.')[0]
            // }, ${place.lat}, ${place.lng})`,
          })
        );
      }

      if (selectedPage === 'table') {
        markers.push(
          new maps.Marker({
            position: {
              lat: parseFloat(place.lat),
              lng: parseFloat(place.lng),
            },
            icon:
              selectedData[idx]?.trackedUnit?.tuType === 'UNIT'
                ? 'assets/img/Unit.svg'
                : selectedData[idx]?.trackedUnit?.tuType === 'PALLET'
                ? 'assets/img/Pallet.svg'
                : selectedData[idx]?.trackedUnit?.tuType === 'CONTAINER'
                ? 'assets/img/Container.svg'
                : 'assets/img/Box.svg',
            map,
            // title: `${place.lat}, ${place.lng}`,
            title: `${selectedData[idx]?.trackedUnit?.trackingId},${selectedData[idx].deviceId} ${
              selectedData[idx].recentData.tm ? `,tm: ${selectedData[idx].recentData.tm}` : ''
            } ${selectedData[idx].recentData.prs ? `,prs: ${selectedData[idx].recentData.prs}` : ''} ${
              selectedData[idx].recentData.h ? `,h: ${selectedData[idx].recentData.h}` : ''
            } `,
            // title: `(${new Date(_date).toISOString().split('T')[0]}:${new Date(_date).toISOString().split('T')[1].split('.')[0]}, ${place.lat}, ${place.lng})`
          })
        );
      }

      if (place.lat && place.lng) bounds.extend(place);
    });

    if (bounds) {
      map.fitBounds(bounds);
      bounds.getCenter();
    }

    if (cluster) {
      const markerCluster = new MarkerClusterer(map, markers, {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        gridSize: 20,
        minimumClusterSize: 5,
      });
    }
    if (polyline) {
      const arrow = {
        path: maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale: 2,
        scaledSize: new maps.Size(100, 100),
        origin: new maps.Point(0, 0), // origin
        anchor: new maps.Point(0, 0), // anchor
        strokeColor: '#01C796',
        rotation: 0,
      };

      const symbolOne = {
        path: 'M -2,0 0,-2 2,0 0,2 z',
        strokeColor: '#F00',
        fillColor: '#F00',
        fillOpacity: 1,
      };

      const symbolThree = {
        path: 'M -2,-2 2,2 M 2,-2 -2,2',
        strokeColor: '#292',
        strokeWeight: 1,
      };
      const newLines = [];
      for (let i = 0; i < places.length - 1; i++) {
        const line = new maps.Polyline({
          path: places.slice(i, i + 2),
          strokeColor: '#00CCFF',
          strokeWidth: 1,
          strokeWeight: 1,
          icons: [
            {
              icon: symbolOne,
              offset: '0%',
            },
            {
              icon: arrow,
              offset: '50%',
            },
            {
              icon: symbolThree,
              offset: '100%',
            },
          ],
        });
        line.setMap(map);
        newLines.push(line);
      }
    }

    if (selectedPage === 'dashboard') {
      // if (deviceType === 'CATM1_TAG') {
      //   const allDiv = document.createElement('div');

      //   AllBtn(allDiv, map, 'all');
      //   map.controls[google.maps.ControlPosition.TOP_LEFT].push(allDiv);

      //   const gpsDiv = document.createElement('div');
      //   AllBtn(gpsDiv, map, 'gps');
      //   map.controls[google.maps.ControlPosition.TOP_LEFT].push(gpsDiv);
      // }

      // const normDiv = document.createElement('div');
      // binBtn(normDiv, map, 'norm');
      // map.controls[google.maps.ControlPosition.TOP_LEFT].push(normDiv);

      // const binDiv = document.createElement('div');
      // binBtn(binDiv, map, 'bin');
      // map.controls[google.maps.ControlPosition.TOP_LEFT].push(binDiv);

      map.addListener('maptypeid_changed', () => {
        const showStreetViewControl = map.getMapTypeId();
        setMaoStyle(showStreetViewControl);
      });

      initFullscreenControl(map);
    }
  };

  function AllBtn(controlDiv, map, type) {
    // Set CSS for the control border.
    const controlUI = document.createElement('div');

    controlUI.style.backgroundColor = '#fff';
    controlUI.style.border = '1px solid #ececec';
    controlUI.style.cursor = 'pointer';
    controlUI.style.marginTop = '8px';
    controlUI.style.marginBottom = '22px';
    if (type === 'all') controlUI.style.marginLeft = '14px';
    controlUI.style.textAlign = 'center';
    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior.
    const controlText = document.createElement('div');

    controlText.style.color = 'rgb(25,25,25)';
    controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
    controlText.style.fontSize = '13px';
    controlText.style.lineHeight = '28px';
    controlText.style.paddingLeft = '9px';
    controlText.style.paddingRight = '9px';
    controlText.style.paddingTop = '5px';
    controlText.style.paddingBottom = '4px';
    controlText.style.fontWeight = '500';

    if (type === 'all') {
      controlText.innerHTML = 'All';
      if (!mapType) {
        controlText.style.color = '#111';
      } else {
        controlText.style.color = '#999';
      }
    } else {
      controlText.innerHTML = 'GPS';
      if (mapType) {
        controlText.style.color = '#111';
      } else {
        controlText.style.color = '#999';
      }
    }

    controlUI.appendChild(controlText);
    // Setup the click event listeners: simply set the map to Chicago.
    if (type === 'all')
      controlUI.addEventListener('click', () => {
        handleMapType(false);
      });
    else
      controlUI.addEventListener('click', () => {
        handleMapType(true);
      });
  }

  function binBtn(controlDiv, map, type) {
    // Set CSS for the control border.
    const controlUI = document.createElement('div');

    controlUI.style.backgroundColor = '#fff';
    controlUI.style.border = '1px solid #ececec';
    controlUI.style.cursor = 'pointer';
    controlUI.style.marginTop = '8px';
    controlUI.style.marginBottom = '22px';
    controlUI.id = type;
    if (type === 'norm') controlUI.style.marginLeft = '14px';
    controlUI.style.textAlign = 'center';
    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior.
    const controlText = document.createElement('div');

    controlText.style.color = 'rgb(25,25,25)';
    controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
    controlText.style.fontSize = '13px';
    controlText.style.lineHeight = '28px';
    controlText.style.paddingLeft = '9px';
    controlText.style.paddingRight = '9px';
    controlText.style.paddingTop = '5px';
    controlText.style.paddingBottom = '4px';
    controlText.style.fontWeight = '500';

    if (type === 'bin') {
      controlText.innerHTML = 'BIN';
      if (bin) {
        controlText.style.color = '#111';
      } else {
        controlText.style.color = '#999';
      }
    } else {
      controlText.innerHTML = 'NORM';
      if (!bin) {
        controlText.style.color = '#111';
      } else {
        controlText.style.color = '#999';
      }
    }

    controlUI.appendChild(controlText);
    // Setup the click event listeners: simply set the map to Chicago.
    if (type === 'bin')
      controlUI.addEventListener('click', () => {
        handleBin(true);
        const k = true;
        if (k) {
          document.getElementById('bin').style.color = '#111';
        } else {
          document.getElementById('norm').style.color = '#999';
        }
      });
    else
      controlUI.addEventListener('click', () => {
        handleBin(false);
        const k = false;
        if (k) {
          document.getElementById('norm').style.color = '#111';
        } else {
          document.getElementById('bin').style.color = '#999';
        }
      });
  }

  function initFullscreenControl(map) {
    const elementToSendFullscreen = document.getElementById('map');
    const mainBtn = document.createElement('button');

    mainBtn.style.background = 'none rgb(255, 255, 255)';
    mainBtn.style.border = '0px';
    mainBtn.style.cursor = 'pointer';
    mainBtn.style.margin = '10px';
    mainBtn.style.padding = '0px';
    mainBtn.style.position = 'absolute';
    mainBtn.style.borderRadius = '2px';
    mainBtn.style.height = '40px';
    mainBtn.style.width = '40px';

    mainBtn.style.boxShadow = 'rgb(0 0 0 / 30%) 0px 1px 4px -1px';
    mainBtn.style.overflow = 'hidden';
    mainBtn.style.top = '0px';
    mainBtn.style.right = '0px';

    const img = document.createElement('img');

    img.src = 'assets/img/full-screen.svg';
    img.id = 'img_map';
    img.style.height = '20px';
    img.style.width = '20px';
    img.style.margin = 'auto';
    if (isFullscreen(elementToSendFullscreen)) {
      img.src = 'assets/img/small-screen.svg';
    } else {
      img.src = 'assets/img/full-screen.svg';
    }
    mainBtn.appendChild(img);

    map.controls[google.maps.ControlPosition.RIGHT_TOP].push(mainBtn);
    mainBtn.onclick = function () {
      if (isFullscreen(elementToSendFullscreen)) {
        document.getElementById('img_map').src = 'assets/img/full-screen.svg';
        exitFullscreen();
      } else {
        document.getElementById('img_map').src = 'assets/img/small-screen.svg';
        requestFullscreen(elementToSendFullscreen);
      }
    };

    document.onwebkitfullscreenchange = document.onmsfullscreenchange = document.onmozfullscreenchange = document.onfullscreenchange = function () {
      if (isFullscreen(elementToSendFullscreen)) {
        mainBtn.classList.add('is-fullscreen');
      } else {
        mainBtn.classList.remove('is-fullscreen');
      }
    };
  }

  function isFullscreen(element) {
    return (
      (document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement) == element
    );
  }

  function requestFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullScreen) {
      element.msRequestFullScreen();
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document
        .exitFullscreen()
        .then(() => console.log('Document Exited from Full screen mode'))
        .catch((err) => console.error(err));
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }

  return (
    <div id="map" className="height_map w-full ">
      <GoogleMapReact
        key={coordinates}
        bootstrapURLKeys={{ key: 'AIzaSyDVsc9GqAbD6BF7vKPaLTNgtFFksrxj0Yw' }}
        options={getMapOptions}
        defaultZoom={11}
        center={center}
        mapId="ef82cbc2846ded4d"
        onGoogleApiLoaded={({ map, maps }) => handlegoogleApi(map, maps, coordinates)}
        yesIWantToUseGoogleMapApiInternals
        // onChange={({ center, zoom, bounds, marginBounds }) => {
        //   if (selectedPage === 'zone')
        //     if (zoom === 22) {
        //       selectedData.forEach((x) => {
        //         x.Address.forEach((y) => {
        //           if (
        //             Math.ceil(y.longitude) === Math.ceil(center.lng) &&
        //             Math.ceil(y.latitude) === Math.ceil(center.lat)
        //           ) {
        //             setZoomedLocationMap(y.floorPlan);
        //           }
        //         });
        //       });
        //       setShowFloorMap(true);
        //     }
        // }}
      />
    </div>
  );
}
export default MapComponent;
